import './toggle.scss';

const Toggle = ({ isOn, handleToggle, label, id="toggle-switch", disabled = false, labelInside = false }) => {
  const containerClass = `form-check form-switch${labelInside ? ' form-switch--label-inside' : ''}`;
  return (
    <div className={containerClass} data-testid="toggle-container">
      <input className='form-check-input' type='checkbox' role='switch' id={id} checked={isOn} onChange={handleToggle} disabled={disabled} data-testid="toggle-input" />
      <label className='form-check-label' htmlFor={id} data-testid="toggle-label">
        {label}
      </label>
    </div>
  );
};

export default Toggle;
